<template>
    <section class="popular-product">
        <title-date-component :titleOption="titleOption"></title-date-component>
        <section class="data-box">
            <rose-component style="width:300px;" :roseInfo="roseInfo"></rose-component>
            <table-component style="width:62%; margin-left:4%;" :tableInfo="tableInfo"></table-component>
        </section>
    </section>
</template>

<style lang="scss" scoped="scoped">
    .popular-product {
        background-color: #FFF;
        padding: 10px 20px 10px 20px;
        margin-top: 60px;
        width: 98%;
        margin-left: 1%;
        .data-box {
            width: 100%;
            height: 300px;
            padding-left: 40px;
            margin-top: 35px;
        }
    }
</style>

<script>
    import TitleDateComponent from '../../../../components/title-date/TitleDate.vue'
    import RoseComponent from '../../../../components/echarts/Rose.vue'
    import TableComponent from '../../../../components/table/Table.vue'
    import menpiaoDataPlatform from 'api/menpiaoDataPlatform'
    import MomentFormat from '../../../../filters/moment-format'
    import percentformat from '../../../../filters/percent-format'

    export default {
        components: {
            TitleDateComponent,
            RoseComponent,
            TableComponent
        },
        data () {
            return {
                titleOption: {
                    title: '7天畅销商品'
                },
                rankType: 1,
                date: {
                    startDate: MomentFormat.getSevenDate(),
                    endDate: MomentFormat.getYestoday()
                },
                roseInfo: [],   // 南丁格尔图数据
                tableInfo: {    // 表格数据
                    title: [
                        {
                            name: '商品名称',
                            value: 'productName',
                            style: 'width:25%;'
                        },
                        {
                            name: '销量',
                            value: 'payQuantity'
                        },
                        {
                            name: '销售额',
                            value: 'payAmount'
                        },
                        {
                            name: '销售占比',
                            value: 'payAmountRate'
                        },
                        {
                            name: '支付转化率',
                            value: 'payRate'
                        },
                        {
                            name: '',
                            value: 'action'
                        }
                    ],
                    data: []
                },
                color: ['#FF2F40', '#FFBC37', '#139BFD', '#1DD978', '#4D7BF3']
            }
        },
        props: ['salePlatform'],
        watch: {
            salePlatform: {
                handler: function () {
                    this.getData();
                },
                deep: true
            }
        },
        methods: {
            getData () {
                menpiaoDataPlatform.getSevenData(this.salePlatform, this.date.endDate, 2, 'payAmount', 2)
                    .then((res) => {
                        console.log(res);
                        if (res.status === 0) {
                            let data = res.data;
                            let arr = [];
                            let roseArr = [];
                            let productId = [];
                            data.forEach((item, index) => {
                                let o = {};
                                o.productName = {};
                                o.productName.value = '<span style="background-color:' + this.color[index] + '">' +
                                    (index + 1) + '</span>' + item.productName;
                                o.payQuantity = {};
                                o.payQuantity.value = item.week.payQuantity;
                                o.payAmount = {};
                                o.payAmount.value = item.week.payAmount;
                                o.payAmountRate = {};
                                o.payAmountRate.value = percentformat(item.week.payAmountRate, true);
                                o.payRate = {};
                                o.payRate.value = percentformat(item.week.payRate, true);
                                o.action = {};
                                o.action.value = '<a href="javascript:void(0);">查看趋势</a>';
                                o.action.showTc = true;
                                o.action.params = {
                                    productId: item.productId,
                                    productName: item.productName,
                                    startDate: this.date.startDate,
                                    endDate: this.date.endDate
                                };
                                roseArr.push({
                                    name: item.productName,
                                    value: item.week.payAmount,
                                    color: this.color[index]
                                });
                                productId.push(item.productId);
                                arr.push(o);
                            });
                            this.roseInfo = roseArr;
                            this.tableInfo.data = arr;
                        } else {
                            this.$notify.error({
                                title: '错误',
                                message: res.message || '请求失败'
                            })
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    })
            }
        },
        mounted () {
            this.getData();
        }
    }
</script>



// WEBPACK FOOTER //
// PopularProduct.vue?4b7e52f4